export default "__VITE_ASSET__B9u7qeYj__"